import APIRecs from "../images/resourceIcons/api-recs.webp";
import PokeApi from "../images/resourceIcons/PokeApi.webp";
import DeckOfCards from "../images/resourceIcons/DeckOfCards.webp";
import Chess from "../images/resourceIcons/ChessApi.webp";
import DnD from "../images/resourceIcons/Dnd5e.webp";
import YGO from "../images/resourceIcons/YGO.webp";
import {Game, GameItem} from "../models/Game";

export const GAMES_TYPES_CONFIG = [
    new Game(
        "coding-challenge-games",
        "Coding Challenge Games",
        "Interactive programming games and challenges to sharpen your coding skills",
        APIRecs,
        "codingChallengeGames",
        false,
        false,
        [
            // new GameItem("CodinGame", "Solve coding puzzles and compete with other developers in engaging programming challenges.", APIRecs, "https://www.codingame.com/"),
        ]
    ),
] 